import { Component } from '@angular/core';

@Component({
  selector: 'cat-page',
  templateUrl: './mail-templates.html'
})

export class ComponentsMailTemplates {}

